import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/info-student/:senderID',
    name: 'HomePageInfoStudents',
    component: () => import(/* webpackChunkName: "Home" */"../views/components/HomePage.vue")
  },
  {
    path: '/search',
    name: 'SearchForm',
    component: () => import(/* webpackChunkName: "Home" */"../views/searchInfo/SearchForm.vue")
  },
  {
    path: '/search/info',
    name: 'Info',
    props: true,
    component: () => import(/* webpackChunkName: "Home" */"../views/searchInfo/HomePage.vue")
  },
  {
      path: '*',
      // component: Login,
      component: () => import(/* webpackChunkName: "NotFoundPage" */"../views/NotFoundPage.vue")
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// router.beforeEach((to, from, next) => {
//   // ...
//   console.log('to: ' + JSON.stringify(to) )
//   console.log('from: ' + JSON.stringify(from) )
//   console.log('next: ' + next )
// })

export default router
